import { useState } from 'react';
import PreferencesFormData from '../interfaces/PreferencesFormData';
import { UserAboutMe, UserAboutMeInput } from '../../../graphql.generated';
import {
    UpdateUserAboutMeDocument,
    UpdateUserAboutMeMutation,
    UpdateUserAboutMeMutationVariables
} from './updateUserAboutMe.generated';
import { useLazyFetchGraphql } from '@zoopla/fetch-graphql';

const useUpdateAboutMe = (onSuccess?: () => void) => {
    const [generalError, setGeneralError] = useState(false);

    const { lazyFetch } = useLazyFetchGraphql<
        UpdateUserAboutMeMutation,
        UpdateUserAboutMeMutationVariables
    >(UpdateUserAboutMeDocument, {
        onCompleted({ updateUserAboutMe: response }) {
            if (!response) {
                setGeneralError(true);
                return;
            }
            onSuccess?.();
        },
        onError() {
            setGeneralError(true);
        }
    });

    const updateAboutMe = (props: PreferencesFormData) => {
        setGeneralError(false);

        const { situation } = props;
        if (!situation) {
            return;
        }

        const input: UserAboutMeInput = {
            situation: situation.id as UserAboutMe
        };

        return lazyFetch({ input });
    };

    return {
        updateAboutMe,
        generalError
    };
};

export default useUpdateAboutMe;
